import React from 'react';
import { supabase } from '../supabaseClient';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import WorksheetCard from '../WorksheetCard';

function Values({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                return;
            }

            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'Values',
                    animated_helper: 'no', // always set to 'no'
                    timestamp: new Date().toISOString(),
                });

            if (progressError) {
                console.error('Error saving progress:', progressError.message);
                alert('Failed to save progress: ' + progressError.message);
                return;
            }

            alert('Progress saved successfully!');
        } catch (err) {
            console.error('Unexpected error saving progress:', err);
            alert('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
        }}>
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'black',
                marginBottom: '32px',
            }}>
                Values
            </h3>

            {/* Session Helper Cards Row */}
            <div
                className="values-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>• What is important to us tells us what our values are</div>
                        <div>• Our values can be prioritized so that we know how to decide when they conflict</div>
                        <div>• Our values can change over time</div>
                        <div>• Everyone's values are personal to them</div>
                        <div>• Integrity comes from living our values</div>
                        <div>• We are not better or worse than anyone else based on what is important to us</div>
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>1. Have you made a list of what is important to you?</div>
                        <div>2. What has shaped your values?</div>
                        <div>3. Have you adopted the values of your family?</div>
                        <div>4. Can you put your values on a list in order of importance? </div>
                        <div>5. How often do you examine your values?</div>
                        <div>6. Do you keep your values private? If so, why?</div>
                    </div>
                </div>
            </div>

            {/* WorksheetCard Section */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
                marginBottom: '24px',
            }}>
                <WorksheetCard title="Values Worksheet" columnName="values" />
            </div>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
            }}>
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        What is important to you? Whatever is important to us is what we want to spend our time experiencing.  It helps to know our priority on our values as well, because when it comes time to make a decision we want to be clear on where we stand.  Knowing what is important to us helps us navigate life while being true to ourselves. It also helps us know ourselves better.  What is important to each of us is up to us, and our list can be updated periodically as needed. 
                    </p>
                </div>

                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        There are some vibrational states that require our free will and courage to raise up from.  That means when we are in one of the lower density loops it requires a conscious choice along with the courage to take the steps out of that loop. Consider that the loops shown on the bottom of the slide are infinitely looping and can keep us limited for a long time if we do not decide to choose differently. 
                    </p>
                    <img
                        src="/images/7%20Sins%20Meme.webp"
                        alt="7 Sins Meme"
                        style={{
                            width: '100%',
                            maxWidth: '360px',
                            height: 'auto',
                            marginBottom: '12px',
                            borderRadius: '8px',
                            border: '1px solid #4B5563',
                            objectFit: 'contain',
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    />
                </div>

                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Any of the "7 deadly sins" can replace Gluttony in this slide.  It is meant to show that the loop of the "sin" and how we can stay in that loop whether we are indulging in the "sin" or judging the "sin". In purple we see the energy balancing formula and how the Acceptance step opens us to use our Free Will and Courage to choose differently.  This is Freedom. When we are looping in the energy there will be an emotionally charged response to the topic.  It may be that we just avoid the topic.  We can avoid the topic out of our free will choice, or we can avoid the topic to avoid the charged emotion around the topic.  One is Freedom, the other is not.
                    </p>
                    <img
                        src="/images/7%20Sins%202%20Meme.webp"
                        alt="7 Sins 2 Meme"
                        style={{
                            width: '100%',
                            maxWidth: '360px',
                            height: 'auto',
                            marginBottom: '12px',
                            borderRadius: '8px',
                            border: '1px solid #4B5563',
                            objectFit: 'contain',
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    />
                </div>
            </div>

            <div
                className="values-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    marginBottom: '16px',
                }}
            >
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goBack}>Back</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goHome}>Home</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={handleSaveProgress}>Save</button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .values-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Values;